/**
 * @file     appLinksLive.ts
 * @purpose  Whether app-link UI is on (NEXT_PUBLIC_APP_LINKS_LIVE). Its own module so shell components can check it without loading the app-claimed path table.
 */

/**
 * Everything user-visible that depends on the app build that consumes these
 * links. The association file and the web fallbacks do not read this.
 */
export function appLinksLive(): boolean {
  const raw = process.env.NEXT_PUBLIC_APP_LINKS_LIVE?.toLowerCase();
  return raw === '1' || raw === 'true';
}
